/**
 * Debug mode
 */

if (window.location.href.match(/\?debug/gi)) {
    document.getElementById('devtools').classList.remove('hidden')
}
